import React, { memo } from "react";
import { FlatList, Platform, Pressable, StyleSheet, Text, View } from "react-native";
import dimensions from "../../globalStyles/dimensions";
import GlobalStyles from "../../globalStyles/globalStyles";
import ModalComponent from "../ModalComponent";
import ExperienceIcons from "../../assets/Icons/ExperienceIcons";
import { BlurView } from "expo-blur";
import CustomComponent from "../../components/CustomComponent";
import { Colors } from "../../globalStyles/ColorConfig";
import { RootState, useSelector } from "../../redux/store";

const WhatsIncludedModal = ({
  visible,
  toggleModal,
}: {
  visible: any;
  toggleModal: any;
}) => {
  const data = [
    { id: 1, name: "Food", desc: "Food from a luxury hotel in Thailand" },
    { id: 2, name: "Drinks", desc: "Drinks from a luxury hotel in Thailand" },
  ];
  const {experience: experienceData } = useSelector((state: RootState) => state.experience)

  return (
    // <CustomModal isVisible={visible} toggleModal={toggleModal}>
    <ModalComponent isVisible={visible} toggleModal={toggleModal}>
      <BlurView
        intensity={50}
        style={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.67)",
          zIndex: 1,
        }}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalWrap}>
            <View style={styles.container}>
              <View style={styles.header}>
                <Text style={[GlobalStyles.heading3]}>What’s included</Text>
                <Pressable onPress={toggleModal}>
                  <ExperienceIcons.Cross />
                </Pressable>
              </View>
              <FlatList
                data={experienceData?.includedPackages}
                keyExtractor={(item) => item?._id}
                renderItem={(item) => (
                  <View style={styles.itemContainer}>
                    <Text style={[GlobalStyles.title2, styles.itemName]}>
                      {item?.item?.includedPackagesName}
                    </Text>
                    <Text style={[GlobalStyles.bodyText, styles.itemDesc]}>
                      {item?.item?.packagesDescription}
                    </Text>
                  </View>
                )}
                showsVerticalScrollIndicator={false}
                ItemSeparatorComponent={() => (
                  <CustomComponent.SolidDivider
                    width={328}
                    height={0.5}
                    backgroundColor={Colors.black90}
                    style={{
                      opacity: 0.3,
                      marginBottom: dimensions.marginVertical,
                    }}
                  />
                )}
              />
            </View>
          </View>
        </View>
      </BlurView>
    </ModalComponent>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: "rgba(169, 169, 169, 0.60)",
    flex: 1,
  },
  modalWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    height: "100%",
  },
  container: {
    position: "absolute",
    paddingHorizontal: Platform.OS === "web" ? 20 : dimensions.paddingHorizontal,
    paddingVertical: Platform.OS === "web" ? 20 : dimensions.paddingVertical,
    backgroundColor: "white",
    bottom: 0,
  
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: dimensions.marginVertical,
  },
  content: {
    flex: 1,
  },
  itemContainer: {
    marginBottom: dimensions.marginVertical,
  },
  itemName: {
    marginBottom: dimensions.marginVertical,
  },
  itemDesc: {
    color: "gray",
  },
});

export default memo(WhatsIncludedModal);
